import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import { installComplianceClient } from './complianceClient';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { canUseAnalytics } from './utils/cookieConsent';

installComplianceClient();


if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/sw.js').catch(() => {});
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
   <BrowserRouter>
    <App />
   </BrowserRouter>
  </React.StrictMode>
);

// Optional analytics / web vitals — only when cookie preference allows.
if (canUseAnalytics()) {
  reportWebVitals();
}

window.addEventListener('vitra-cookie-consent', (event) => {
  if (event?.detail?.analytics) {
    reportWebVitals();
  }
});
